import {Selector} from '@ngxs/store';
import {IMediaItem} from '@interfaces/media';
import {FallbackStateModel} from '@store/fallback/fallback-state.model';
import {FallbackState} from '@store/fallback/fallback.state';

export class FallbackSelectors {
  @Selector([FallbackState])
  static getFallbackMedia(state: FallbackStateModel): IMediaItem | null {
    return state.fallbackMedia;
  }

  @Selector([FallbackState])
  static getBlackFallbackStatus(state: FallbackStateModel): boolean {
    return state.blackFallback;
  }

  @Selector([FallbackState])
  static getFallbackMediaToUpdate(state: FallbackStateModel): IMediaItem | null {
    return state.fallbackMediaToUpdate;
  }
}
